/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Agenda_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update your agenda" |
*
* @param {Tournaments_Agenda_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_agenda_error = /** @type {((inputs?: Tournaments_Agenda_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Agenda_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de mettre à jour votre agenda")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo actualizar su agenda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível atualizar sua agenda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiornare la tua agenda")
	return /** @type {LocalizedString} */ ("Could not update your agenda")
});